<script>
import { mapActions, mapGetters } from 'vuex';
import SubmitDialog from './components/submitDialog';

export default {
  name: 'FeedbackButton',
  components: {
    SubmitDialog,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('feedbackButton', ['openDialog']),
    ...mapGetters('feedbackButton', ['getIsDialogDisplayed']),
  },
};
</script>

<template>
  <div>
    <v-btn flat @click.native="openDialog()">
      Feedback
    </v-btn>

    <submit-dialog :visible="getIsDialogDisplayed()" />
  </div>
</template>
